import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { img } from "../lib/api";
import { Reveal } from "../components/Reveal";

export default function Journal() {
  const [articles, setArticles] = useState([]);
  useEffect(() => { api.get("/journal").then(r => setArticles(r.data)); }, []);
  const [feat, ...rest] = articles;
  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-14">
      <span className="eyebrow text-moss">Editorial</span>
      <h1 className="serif text-5xl lg:text-6xl mt-2 mb-12">Meghalaya Journal</h1>
      {feat && (
        <Reveal><Link to={`/journal/${feat.slug}`} className="group grid lg:grid-cols-2 gap-10 mb-20 items-center">
          <div className="overflow-hidden aspect-[4/3]"><img src={img(feat.cover)} alt={feat.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
          <div><span className="eyebrow text-moss">{feat.category}</span><h2 className="serif text-4xl lg:text-5xl mt-3 mb-4">{feat.title}</h2><p className="text-forest/65 leading-relaxed mb-4">{feat.excerpt}</p><span className="text-xs uppercase tracking-[0.16em] underline">Read Article</span></div>
        </Link></Reveal>
      )}
      <div className="grid md:grid-cols-3 gap-10">
        {rest.map((a) => (
          <Reveal key={a.slug}><Link to={`/journal/${a.slug}`} className="group block">
            <div className="overflow-hidden aspect-[4/3] mb-5"><img src={img(a.cover)} alt={a.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
            <span className="eyebrow text-moss">{a.category}</span><h3 className="serif text-2xl mt-2 mb-2">{a.title}</h3><p className="text-sm text-forest/60 line-clamp-2">{a.excerpt}</p>
          </Link></Reveal>
        ))}
      </div>
    </div>
  );
}
